export const bulkOperationsMutationKeys = {
  UPDATE_BULK_PINS: 'updateBulkPins',
  UPDATE_BULK_TASKS: 'updateBulkTasks',
  CREATE_BULK_TASKS: 'createBulkTasks',
  HIDE_OPERATIONS: 'hideOperations',
  ADD_BULK_PINS_TO_GROUP: 'addBulkPinsToGroup'
}

export const bulkOperationsQueryKeys = {
  BULK_TRACK_OPERATION: 'bulkTrackOperation',
  BULK_TRACK_OPERATIONS_LIST: 'bulkTrackOperationList'
}

export const bulkOperationsTaskState = {
  OVERDUE: 'Overdue',
  DONE: 'Done',
  OPEN: 'Open',
  INACTIVE: 'Inactive',
  CLOSED: 'Closed',
  REJECTED: 'Rejected'
}
